import type {
	Components,
} from '@mui/material'

export const materialUIBadgeTheme: {
	components: Components
} = {
	components: {
		MuiBadge: {
			styleOverrides: {
			},
		},
	},
}
